import { Button, Card, Result } from "antd";
import { FLOWS, useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";
import React from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const JobSuccess = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const isFlow = flow === FLOWS.APPROVAL;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <Card size="small">
      <Result
        status={"success"}
        title="Hoàn tất sửa lỗi"
        subTitle="File của bạn đã được xử lý xong toàn bộ. Xin vui lòng thanh toán phần còn lại để nhận được bản dịch hoàn chỉnh"
        extra={[
          <Button style={{ width: 200, borderRadius: 5 }} type="primary">
            Thanh toán
          </Button>,
        ]}
      />
    </Card>
  );
};
export default JobSuccess;
